import store from '../store/store';

/* Track anon users using the cookie ClientId */
export default function getUserClientId(): string {
    return store.bookingData?.UserClientId ?? '';
}
